export default [
    {
        value: "EmProducao",
        text: "Em produção",
        variant: "info"
    },
    {
        value: "Pendente",
        text: "Pendente",
        variant: "warning"
    },
    {
        value: "EmAtraso",
        text: "Em atraso",
        variant: "danger"
    },
    {
        value: "Finalizada",
        text: "Finalizada",
        variant: "success"
    }
]